import { api } from "@/api";
import type { EmailOptions, EmailOptionsSettings } from "./types";

/**
 * The BFF returns saves as HTTP 200 with a { success, error } envelope so the message
 * survives the shared axios error interceptor, which discards response bodies.
 */
type Result = { success: boolean; error: string | null };

export const getEmailOptions = async (): Promise<EmailOptions> => {
  const response = await api.get<EmailOptions>("/email-options");
  return response.data;
};

export const saveEmailOptions = async (settings: EmailOptionsSettings): Promise<void> => {
  const response = await api.put<Result>("/email-options", settings);
  if (!response.data.success) {
    throw new Error(response.data.error ?? "We couldn't save the email options. Please try again.");
  }
};
